import React, { Fragment } from "react";

export const About = () => {
  return (
    <Fragment>
      <div>
        <h1> About This App </h1> <p> App to search Github users </p>{" "}
        <p> Version: 1.0 .0 </p>{" "}
      </div>
    </Fragment>
  );
};

export default About;
